import React, { ReactNode } from "react";
import cn from "classnames";
import c from "../../styles/container.module.scss";
import s from "./InteractiveGrid.module.scss";
import bs from "../../styles/block.spacing.module.scss";
import ItemNonTouch from "./components/ItemNonTouch";
import ItemTouch from "./components/ItemTouch";
import BlockIntro from "../Common/BlockIntro";
import BlockBackground from "../Common/BlockBackground";
import { RichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";
import { useInView } from "react-intersection-observer";

type Props = {
  title: string;
  description: RichTextContent;
  buttons?: ReactNode;
  children: ReactNode;
  style?: string;
  blockStyle?: string;
  innerSpacing: string;
  outerSpacing: string;
  inverted?: boolean;
};

const InteractiveGrid: React.FC<Props> & {
  ItemNonTouch: typeof ItemNonTouch;
  ItemTouch: typeof ItemTouch;
} = ({
  title,
  description,
  buttons,
  children,
  style = "none",
  innerSpacing,
  outerSpacing,
  inverted,
}) => {
  const { ref: sectionRef, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    rootMargin: "100px",
  });

  return (
    <section
      className={cn(s.interactiveGrid, bs[innerSpacing], bs[outerSpacing])}
      aria-label={title}
      ref={sectionRef}
    >
      <BlockBackground style={style} opacity={100} />
      <BlockIntro
        inverted={inverted}
        title={title}
        description={description}
        buttons={buttons}
        alignment={"alignCenter"}
        width={"contained"}
      />
      {inView && (
        <div className={cn(s.interactiveGridInner, c.xxWide)}>{children}</div>
      )}
    </section>
  );
};

InteractiveGrid.ItemNonTouch = ItemNonTouch;
InteractiveGrid.ItemTouch = ItemTouch;

export default InteractiveGrid;
